import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios, { CancelToken } from "axios";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import { GetFloorPlans, IFloorPlan } from "api/rpc/2024-04/facilityAdmin/tables/tables";

export default function FloorPlans() {
  const history = useHistory();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const [floorPlans, setFloorPlans] = useState<IFloorPlan[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadFloorPlans(source.token);
    return () => source.cancel();
  }, []);

  async function loadFloorPlans(token?: CancelToken) {
    if (floorPlans !== undefined) {
      setFloorPlans(undefined);
    }
    const res = await GetFloorPlans({}, token ? false : true, token);

    if (token && token.reason) {
      return;
    }
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Failed to load floor plans")));
    }

    setFloorPlans(res.status !== StatusCode.OK ? [] : res.data);
  }

  const primaryAction = {
    content: t("Create"),
    action: () => history.push("/admin/settings/floor-plan/new"),
  };

  return (
    <Page
      title={t("Floor Plans")}
      narrow
      primaryAction={primaryAction}
    >
      <DataTable
        columns={[{ label: t("Title") }]}
        loading={floorPlans === undefined}
      >
        {floorPlans?.map(plan => (
          <tr
            key={plan.id}
            className="clickable"
            onClick={() => history.push("/admin/settings/floor-plan/" + String(plan.id))}
          >
            <td>{plan.title}</td>
          </tr>
        ))}
      </DataTable>
    </Page>
  );
}
